"use strict";

require("core-js/modules/es6.object.define-property");

require("core-js/modules/es6.object.define-property");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _axios = _interopRequireDefault(require("axios"));

var _EbookCardSkeleton = _interopRequireDefault(require("./EbookCardSkeleton"));

var _EbookCardRender = _interopRequireDefault(require("./EbookCardRender"));

var _EbookCardDownloadLink = _interopRequireDefault(require("./EbookCardDownloadLink"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
} //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


var _default = {
  name: 'ebook-card',
  props: ['ebook'],
  components: {
    EbookCardSkeleton: _EbookCardSkeleton["default"],
    EbookCardRender: _EbookCardRender["default"],
    EbookCardDownloadLink: _EbookCardDownloadLink["default"]
  },
  data: function data() {
    return {
      productLoaded: true,
      isFailed: false,
      cardDetails: {
        image: {
          'url': '#',
          'alt': ''
        },
        title: '',
        url: '',
        variants: {}
      },
      productData: {},
      handle: this.ebook.handle
    };
  },
  methods: {
    setFailedState: function setFailedState() {
      this.productLoaded = false;
      this.isFailed = true;
      this.cardDetails.title = '';
      this.cardDetails.url = '';
      this.cardDetails.variants = '';
      this.setProductImage('noCover');
    },
    setSuccessState: function setSuccessState(data) {
      this.productLoaded = true;
      this.isFailed = false;
      this.productData = data;
      this.cardDetails.title = data.title;
      this.cardDetails.url = data.url;
      this.cardDetails.variants = data.variants;
      this.setProductImage('success');
    },
    getProductData: function getProductData(ebook) {
      var _this = this;

      var handle = ebook.handle;

      _axios["default"].get("/products/".concat(handle, ".js")).then(function (response) {
        _this.setSuccessState(response.data);

        return response;
      })["catch"](function (err) {
        _this.setFailedState();

        console.error(err);
        return err;
      });
    },
    searchProduct: function searchProduct(ebook) {
      var _this2 = this;

      var sku = ebook.sku;

      _axios["default"].get("/search?type=product&q=".concat(sku, "&view=related-products")).then(function (response) {
        var productData = response.data[0];

        if (productData === undefined) {
          _this2.setFailedState();

          return;
        }

        _this2.setSuccessState(productData);

        _this2.handle = productData.productHandle;
        return response;
      })["catch"](function (err) {
        _this2.setFailedState();

        console.error(err);
        return err;
      });
    },
    setProductImage: function setProductImage(status) {
      // Available on both Libre & Shopify.
      if (status === 'success') {
        if (this.productData.hasOwnProperty('images')) {
          this.cardDetails.image.url = this.productData.images[0];
          this.cardDetails.image.alt = '';
        } // Not available for download on both Libre or Shopify

      } else if (status === 'discontinued' || status === 'failed') {
        this.cardDetails.image.url = "https://cdn.shopify.com/s/files/1/0040/4681/5305/files/discontinued.png?v=1579531327";
        this.cardDetails.image.alt = "eBook Discontinued"; // Available for download on Libre, but not on Shopify
      } else if (status === 'noCover') {
        this.cardDetails.image.url = "https://cdn.shopify.com/s/files/1/0040/4681/5305/files/MAB_-_Cover_unavailable.jpeg?v=1581954930";
        this.cardDetails.image.alt = "eBook Cover Unavailable";
      }
    },
    performSearch: function performSearch(ebook) {
      if (!ebook) {
        ebook = this.ebook;
      }

      if (ebook.handle.length < 1) {
        this.searchProduct(ebook);
      } else {
        this.getProductData(ebook);
      }
    }
  },
  mounted: function mounted() {
    this.setProductImage('noCover');
    this.performSearch(this.ebook);
  }
};
exports["default"] = _default;